/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountState } from '../models/AccountState';

export class SourceAwsOrganizationalUnit {
  /**
  * Eon-assigned organizational unit ID.
  */
  'id': string;
  /**
  * ARN of the role Eon assumes to access the organizational unit in AWS.
  */
  'roleArn': string;
  /**
  * The organizational unit display name in Eon.
  */
  'name': string;
  /**
  * AWS Organizational Unit ID.
  */
  'providerOrganizationalUnitId': string;
  /**
  * AWS Organization management account ID.
  */
  'providerManagementAccountId': string;
  'status': AccountState;
  /**
  * Number of individual AWS accounts linked to this organizational unit.
  */
  'accountCount'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "roleArn",
      "baseName": "roleArn",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerOrganizationalUnitId",
      "baseName": "providerOrganizationalUnitId",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerManagementAccountId",
      "baseName": "providerManagementAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "AccountState",
      "format": ""
    },
    {
      "name": "accountCount",
      "baseName": "accountCount",
      "type": "number",
      "format": "int32"
    }  ];

  static getAttributeTypeMap() {
    return SourceAwsOrganizationalUnit.attributeTypeMap;
  }

  public constructor() {
  }
}



